
import { PropsWithChildren, useEffect } from "react";
import { usePageTracking } from "@/hooks/useAnalytics";
import Navbar from "@/components/Navbar";

interface MainLayoutProps extends PropsWithChildren {
  // You can add specific props for the layout here if needed
}

const MainLayout = ({ children }: MainLayoutProps) => {
  // Track page views
  usePageTracking();
  
  // Add performance metrics tracking
  useEffect(() => {
    // Mark the start of render
    performance.mark('render-start');
    
    return () => {
      // Mark the end of render
      performance.mark('render-end');
      
      // Measure the time between start and end
      try {
        performance.measure('render-duration', 'render-start', 'render-end');
        
        // Log the measurement
        const measurements = performance.getEntriesByName('render-duration');
        if (measurements.length > 0) {
          console.log(`Page render time: ${measurements[0].duration.toFixed(2)}ms`);
        }
        
        // Clean up marks
        performance.clearMarks('render-start');
        performance.clearMarks('render-end');
        performance.clearMeasures('render-duration');
      } catch (e) {
        console.error('Error measuring performance', e);
      }
    };
  }, []);
  
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow">
        {children}
      </main>
      {/* Footer is added in individual page components */}
    </div>
  );
};

export default MainLayout;
